export default __webpack_public_path__ + "static/13_21-7770a6ec08b20029d8b921c5745f37a7.png";